import { Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { useBranding } from "@/hooks/useBranding";

const Footer = () => {
  const branding = useBranding();
  const legalLinks = [
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms of Service", href: "/terms" },
    { label: "HIPAA Compliance", href: "/hipaa" },
    { label: "Accessibility", href: "/accessibility" },
  ];

  return (
    <footer className="bg-charcoal text-card/90">
      <div className="container py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid gap-8 md:grid-cols-2">
          <div>
            <div className="mb-4 flex items-center gap-2.5" aria-label={branding.name}>
              {branding.footerLogoUrl ? (
                <img
                  src={branding.footerLogoUrl}
                  alt={`${branding.name} logo`}
                  className="h-10 w-auto max-w-48 object-contain"
                />
              ) : (
                <>
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary font-bold text-primary-foreground">
                    {branding.initials}
                  </span>
                  <span className="text-2xl font-bold text-card">{branding.name}</span>
                </>
              )}
            </div>
            <div className="space-y-2 text-sm text-card/60">
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                <span>{branding.supportEmail}</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4" />
                <span>{branding.supportPhone}</span>
              </div>
            </div>
          </div>

          <div className="md:text-right">
            <h4 className="font-semibold text-card mb-4">Legal</h4>
            <ul className="space-y-2">
              {legalLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    onClick={() => window.scrollTo(0, 0)}
                    className="text-sm text-card/60 hover:text-primary transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-card/10">
        <div className="container py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-card/50">
              &copy; {new Date().getFullYear()} {branding.copyright}
            </p>
            <p className="text-xs text-card/60 max-w-2xl text-center md:text-right">
              {branding.disclaimer}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
